// extracted by mini-css-extract-plugin
export default {"baseSelect":"styles_baseSelect__Qk44G","largeSelect":"styles_largeSelect__X1aox"};